import React, { useState, useContext } from "react";
import Navigation from "./Navigation";
export const Home = () => {
  return (
    <div className="home">
      <Navigation />
    </div>
  );
};
